import type { CoreLocation, CoreState } from '../../types'

export const getLocationsUnderCollections = (
  state: CoreState
): Array<{
  id: string
  name: string | undefined
}> => {
  const getLocation = (locationId: string): CoreLocation | undefined =>
    state.locations.find((location) => {
      return location.id === locationId
    })

  return (
    state.billingSettings
      // Note: paymentStatus can be 'paid' with a paymentFailedAt date. This captures locations that have failed payments but are not yet in collections.
      .filter((setting) => setting.status.paymentFailedAt !== null)
      .map((setting) => ({
        id: setting.locationId,
        name: getLocation(setting.locationId)?.name,
      }))
  )
}
